import { breakpoints } from "../../../constants/breakpoints/breakpoints.js";
import "@mui/material/styles";
import "../../../themes/shadows/shadows.js";
import "../../../themes/typography/typography.js";
import "@mui/material";
import "../../../themes/typography/utils/defaultVariantMapping/defaultVariantMapping.js";
import "../../../themes/typography/utils/typographyVariants/typographyVariants.js";
const drPindurUrl = "https://ucarecdn.com/0e8d94f6-e744-4185-8f59-575cb6053122/";
const drMulavdicUrl = "https://ucarecdn.com/f84b828e-56ec-4123-a6db-322a7194a481/";
const drSevinc = "https://ucarecdn.com/7a14aaf2-ea8c-4cc4-aaee-d414a534e276/";
const drKaube = "https://ucarecdn.com/2b27b206-2034-4684-856e-77a202f4bbef/";
const drSpecht = "https://ucarecdn.com/027a5e41-1658-480a-9d22-53eaf8350bae/";
const AUTHOR_IMG_PLACEHOLDER = "https://ucarecdn.com/361407e2-f7a2-44ec-844b-10991d7b4f3a/";
const gallerySettings = {
  arrows: true,
  variableWidth: true,
  adaptiveHeight: true,
  responsive: [
    {
      breakpoint: breakpoints.values.xl,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        arrows: true
      }
    },
    {
      breakpoint: breakpoints.values.lg,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false
      }
    }
  ]
};
const PractitionerTestimonials = [
  {
    id: 1,
    name: "Dr. Pindur",
    image: drPindurUrl,
    en: {
      testimonial: "What's truly important to me is the team, my colleagues. I want to feel happy going to work every day. While I find enjoyment in the work itself, having good communication with the team is equally crucial. This aspect holds significant importance for me, and fortunately, we get along really well here.",
      position: "Dental Lead"
    },
    de: {
      testimonial: "Was mir wirklich wichtig ist, ist das Team, meine Kolleginnen & Kollegen. Ich möchte jeden Tag mit Freude zur Arbeit gehen. Die Arbeit an sich macht mir Spaß, aber genauso wichtig ist eine gute Kommunikation mit dem Team. Dieser Aspekt ist für mich sehr wichtig, und glücklicherweise kommen wir hier sehr gut miteinander aus.",
      position: "Zahnärztliche Leitung"
    }
  },
  {
    id: 2,
    name: "A. Mulavdic",
    image: drMulavdicUrl,
    en: {
      testimonial: "I received a very warm welcome, and it felt like I had always been here. It just clicked, and I knew it was a good fit. Moreover, the working hours are favorable, something I didn't experience in my former company. This allows for a good balance, ensuring there's still time for life outside of work.",
      position: "Clinic Manager"
    },
    de: {
      testimonial: 'Ich wurde sehr herzlich empfangen, und ich hatte das Gefühl, als wäre ich schon immer hier gewesen. Es hat einfach "Klick" gemacht, und ich wusste, dass ich hier gut reinpasse. Außerdem sind die Arbeitszeiten sehr günstig, was ich in meinem früheren Unternehmen nicht erlebt habe. Das sorgt für einen guten Ausgleich, so dass auch noch Zeit für das Leben außerhalb der Arbeit bleibt.',
      position: "Praxismanagerin"
    }
  },
  {
    id: 3,
    name: "T. Sevinc",
    image: drSevinc,
    en: {
      testimonial: "It’s an open-minded environment here, and I truly appreciate that. Dental21 has given me the freedom to choose most of the tools. They genuinely value my advice and opinions, and it's a great feeling when someone listens to you",
      position: "Dental Lead"
    },
    de: {
      testimonial: "Es ist ein offenes Umfeld hier, das schätze ich sehr. Dental21 hat mir die Freiheit gegeben, die meisten Werkzeuge selbst auszuwählen. Mein Rat und meine Meinung werden hier wirklich geschätzt, und es ist ein tolles Gefühl, wenn einem jemand zuhört.",
      position: "Zahnärztlicher Leiter"
    }
  },
  {
    id: 4,
    name: "K. Taube",
    image: drKaube,
    en: {
      testimonial: "There are certain conditions that matter to me. For example, having the freedom to actively contribute and influence processes, sharing my knowledge in the clinic, and developing it here. I also appreciate an intuitive management style, where superiors see themselves as partners. Working in a team is another important aspect for me, and I've found that here.",
      position: "Hygienist and Clinic Manager"
    },
    de: {
      testimonial: "Es gibt bestimmte Bedingungen, die für mich wichtig sind, zum Beispiel: die Freiheit, aktiv beizutragen und Prozesse zu beeinflussen, mein Wissen in der Praxis zu teilen und hier weiterzuentwickeln. Ich schätze auch einen intuitiven Führungsstil, bei dem Vorgesetzte sich als Partner sehen. Das Arbeiten im Team ist ein weiterer wichtiger Aspekt für mich, und das habe ich hier gefunden.",
      position: "Dentalhygienikerin und Prophylaxe Managerin"
    }
  },
  {
    id: 5,
    name: "D.Specht",
    image: drSpecht,
    en: {
      testimonial: "Generally, there is a very open and easy atmosphere. It's not as if you have to hide certain aspects or can't be yourself. Here, you can just be who you are, and everyone accepts each other. Likewise, you accept everyone for who they are.",
      position: "Dentist"
    },
    de: {
      testimonial: "Generell herrscht hier eine sehr offene und lockere Atmosphäre. Es ist nicht so, als müssten bestimmte Aspekte versteckt werden oder als könnte man nicht man selbst sein. Hier kann man einfach man selbst sein, und jeder akzeptiert einander. Genauso akzeptiert man die anderen auch so, wie sie sind.",
      position: "Zahnarzt"
    }
  }
];
export {
  AUTHOR_IMG_PLACEHOLDER,
  PractitionerTestimonials,
  drKaube,
  drMulavdicUrl,
  drPindurUrl,
  drSevinc,
  drSpecht,
  gallerySettings
};
